// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_container__2Z4oZ","checkmark":"CheckBox_checkmark__1Le3l"};